// ─────────────────────────────────────────────────────────────────────────────
// D4 (2026-09-30) — quién ve los puntos de una campaña en Reportería y en el Tablero.
//
// Cambia la «regla de oro #1» (los puntos nunca viajan a Reportería) a pedido del cliente, con dos
// límites que no se relajan:
//   · Solo administradores de puntos: los mismos roles que `v1/rules/points/by-campaign` autoriza
//     (`PointsAdminRoles` de RulesEngine). La autoridad es el servidor; esto solo evita pedir algo
//     que va a responder 403 y pintar una tarjeta que nadie más debe ver.
//   · Solo campañas con «Aplican puntos». Una campaña sin puntos OCULTA la tarjeta —no la pone en
//     cero—, como pide RN-P04 para la columna de Puntos de Históricos. En el Excel la fila va siempre
//     con «Sin puntos»/«No disponible» (BJQ-3, 2026-10-02).
//
// 2026-10-05 — columna «Puntos» POR reconocimiento en «Todos los reconocimientos». El valor sale del
// endpoint CRUDO de RulesEngine (`points-by-recognitions-raw`), que desde esta fecha admite los mismos
// roles que la tarjeta y con su mismo alcance (AdminGlobal/AdminBrillamos el tenant completo,
// AdminOUBrillamos su OU), y ninguno de los dos excluye ya a quien consulta: la suma cuadra.
// ─────────────────────────────────────────────────────────────────────────────
import type { CampaignDto } from '@/api/recognition';

export const ROLES_QUE_VEN_PUNTOS = ['AdminGlobal', 'AdminBrillamos', 'AdminOUBrillamos'] as const;

export function puedeVerPuntos(roles: readonly string[]): boolean {
  return roles.some((rol) => (ROLES_QUE_VEN_PUNTOS as readonly string[]).includes(rol));
}

export function campanaConPuntos(campana: CampaignDto | null | undefined): boolean {
  return Boolean(campana?.visibilidad?.aplicanPuntos);
}
